export default __webpack_public_path__ + "static/media/Óticas-Carol.9fefdb82.png";